export const ERROR_WORKSPACE_EXISTS = 'Workspace with the same name already exists';



// WEBPACK FOOTER //
// ./src/js/constants/workspaces.js